import createQueries from 'styled-kit/utils/createQueries'

export const styledKitMediaQueries = createQueries({
  mobile: '(max-width: 767px)',
  desktop: '(min-width: 768px)'
})
